import { render, staticRenderFns } from "./EventSidebarFooter.vue?vue&type=template&id=0e9c0ebb&"
import script from "./EventSidebarFooter.vue?vue&type=script&lang=js&"
export * from "./EventSidebarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports